/**
 * Conversations API
 */

import { apiClient } from './client';
import type {
  ListConversationsParams,
  ListConversationsResponse,
  AssignConversationRequest,
  AssignConversationResponse,
} from './types';

/**
 * List conversations with pagination and filters
 */
export async function listConversations(
  params: ListConversationsParams
): Promise<ListConversationsResponse> {
  return apiClient<ListConversationsResponse>('list-conversations', {
    params: {
      status: params.status,
      assigned_to: params.assignedTo,
      limit: params.limit,
      cursor: params.cursor,
      since: params.since,
    },
  });
}

/**
 * Assign or unassign a conversation to an operator
 */
export async function assignConversation(
  request: AssignConversationRequest
): Promise<AssignConversationResponse> {
  return apiClient<AssignConversationResponse>('assign-conversation', {
    method: 'POST',
    body: request,
  });
}
